/* Eleganza 2026 — UI gedrag.
   De scroll-reveal is bewust verwijderd: fade-up op elke sectie is de
   verzadigde default, en het verbergen-tot-zichtbaar (opacity 0) liet in de
   praktijk hele rijen kaarten onzichtbaar. De enige choreografie staat nu in
   CSS op de hero (first load), waar niets van content-zichtbaarheid afhangt. */
/* Eleganza 2026 — PDP variant row: when a model has many colourways, append a
   "+N variaties" tile at the end of the swipe row that links to the PLP with
   every colourway (search on the model code). */
(function () {
  "use strict";
  try {
    if (!/\/products\//.test(location.pathname)) return;
    var done = false;
    function build() {
      if (done) return;
      var picker = document.querySelector("#variant-image-picker, .variant-swatch-list");
      if (!picker) return;
      var swatches = picker.querySelectorAll(".variant-swatch:not(.e-variant-more)");
      if (swatches.length <= 5) return;                 // few colours → nothing to add
      if (picker.querySelector(".e-variant-more")) { done = true; return; }
      var tile = document.querySelector("#variant-image-tile");
      var meta = tile && tile.getAttribute("data-meta");
      if (!meta) return;
      var others = swatches.length - 1;
      var a = document.createElement("a");
      a.className = "variant-swatch e-variant-more";
      a.href = "/search?q=" + encodeURIComponent(meta) + "&type=product";
      a.setAttribute("aria-label", "Bekijk alle " + swatches.length + " kleuren");
      a.innerHTML = '<span class="e-variant-more__n">+' + others + '</span><span class="e-variant-more__l">variaties</span>';
      picker.appendChild(a);
      done = true;
    }
    build();
    var host = document.querySelector(".product-form") || document.querySelector("main") || document.body;
    if (host && "MutationObserver" in window) {
      var mo = new MutationObserver(function () { build(); if (done) mo.disconnect(); });
      mo.observe(host, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 8000);
    }
  } catch (e) {}
})();

/* Eleganza 2026 — sold-out sizes get a teal MAIL badge up-front.
   Focal doesn't flag which sizes are gone until you click one, so we derive
   availability from the product JSON (/products/handle.js) for the currently
   selected colour and badge the sold-out size chips. Clicking a badged size
   still selects it → Focal shows unavailable → the Klaviyo back-in-stock form
   appears so the shopper can be emailed when it returns. */
(function () {
  "use strict";
  if (!(document.querySelector(".product-form") || document.querySelector("[id^=MainPaymentContainer]") ||
        /\/products\//.test(location.pathname))) return;

  var MAIL = '<svg viewBox="0 0 24 24" fill="none"><path d="M4 6.5A1.5 1.5 0 0 1 5.5 5h13A1.5 1.5 0 0 1 20 6.5v11A1.5 1.5 0 0 1 18.5 19h-13A1.5 1.5 0 0 1 4 17.5v-11Z" stroke="currentColor" stroke-width="1.6"/><path d="m4.5 7 7.5 5.5L19.5 7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  var product = null;

  function norm(s) { return (s || "").toString().trim().toLowerCase(); }

  function badge(label, on) {
    var has = label.querySelector(".e-soldout-mail");
    if (on && !has) {
      label.classList.add("e-soldout");
      var b = document.createElement("span");
      b.className = "e-soldout-mail"; b.innerHTML = MAIL;
      b.setAttribute("title", "Uitverkocht — mail mij zodra deze maat terug is");
      label.appendChild(b);
    } else if (!on && has) {
      label.classList.remove("e-soldout"); has.remove();
    }
  }

  function refresh() {
    if (!product || !product.options) return;
    var names = product.options.map(function (o) { return norm(o.name || o); });
    var sizeIdx = names.findIndex(function (n) { return /maat|size|schoenmaat/.test(n); });
    if (sizeIdx < 0) return;
    var otherIdx = names.findIndex(function (n, i) { return i !== sizeIdx; });

    // currently selected value of the non-size option (colour)
    var curOther = null;
    if (otherIdx >= 0) {
      var otherVals = product.variants.map(function (v) { return v["option" + (otherIdx + 1)]; });
      var checked = [].slice.call(document.querySelectorAll(".product-form input:checked, .product-form option:checked"))
        .map(function (i) { return i.value; });
      curOther = otherVals.find(function (c) { return checked.indexOf(c) !== -1; });
      if (!curOther) { var fa = product.variants.find(function (v) { return v.available; }) || product.variants[0]; curOther = fa && fa["option" + (otherIdx + 1)]; }
    }

    var sizeValues = (product.options[sizeIdx].values || product.options[sizeIdx]) || [];
    document.querySelectorAll(".block-swatch__item").forEach(function (label) {
      var txt = label.textContent.trim();
      if (sizeValues.map(norm).indexOf(norm(txt)) === -1) return;   // only size chips
      var variant = product.variants.find(function (v) {
        return norm(v["option" + (sizeIdx + 1)]) === norm(txt) &&
               (otherIdx < 0 || norm(v["option" + (otherIdx + 1)]) === norm(curOther));
      });
      badge(label, !!(variant && !variant.available));
    });
  }

  try {
    var url = location.pathname.replace(/\/$/, "") + ".js";
    fetch(url, { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return;
        product = p;
        refresh();
        var n = 0, iv = setInterval(function () { refresh(); if (++n > 12) clearInterval(iv); }, 500);
        document.addEventListener("variant:changed", refresh);
        document.addEventListener("change", function (e) {
          if (e.target && e.target.closest && e.target.closest(".product-form")) setTimeout(refresh, 60);
        });
      })
      .catch(function () {});
  } catch (e) {}
})();

/* ---------------------------------------------------------------------------
   Spaties terug in gesplitste koppen (01-09-2026).

   Focal's <split-lines> knipt een kop op in één <span> per beeldregel en doet
   op elke regel een trim(). Op het scherm klopt dat, maar in de tekst van de
   DOM valt daarmee de spatie op de regelovergang weg: wie de pagina uitleest
   krijgt "Veja schoenenvoor dames", "Sale HerenZwembroeken", "Dames Pumps&
   High Heels". Dat kwam terug in de crawl van 20 categoriekoppen. Het speelt
   alleen als een kop over twee regels loopt — op mobiel dus bijna altijd.

   We hangen achter elke regel behalve de laatste een spatie. Een spatie aan het
   eind van een regel klapt de browser weg, dus het beeld verandert niet.
   ------------------------------------------------------------------------ */
(function () {
  "use strict";

  function herstelSpaties(el) {
    var regels = el.children;
    if (regels.length < 2) return;
    for (var i = 0; i < regels.length - 1; i++) {
      if (regels[i].textContent.slice(-1) === " ") continue;
      regels[i].appendChild(document.createTextNode(" "));
    }
  }

  function volg(el) {
    if (el.dataset.spatieherstel) return;
    el.dataset.spatieherstel = "1";
    herstelSpaties(el);
    // split-lines hersplitst bij resize; dan staat de tekst er weer zonder spatie.
    new MutationObserver(function () { herstelSpaties(el); })
      .observe(el, { childList: true });
  }

  function scan() {
    var lijst = document.querySelectorAll("split-lines");
    for (var i = 0; i < lijst.length; i++) volg(lijst[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }
  window.addEventListener("load", scan);
})();


/* UGG-verzorging als add-on in de wagen (7-10-2026) — snippets/eleganza-ugg-addon.liquid */
document.addEventListener('click', async function (e) {
  var knop = e.target.closest('[data-ugg-addon]');
  if (!knop || knop.disabled) return;
  e.preventDefault();
  knop.disabled = true;
  knop.setAttribute('aria-busy', 'true');
  try {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var r = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: Number(knop.getAttribute('data-ugg-addon')), quantity: 1, properties: { _bron: 'ugg-addon' } })
    });
    if (!r.ok) throw new Error('toevoegen mislukt');
    if (document.querySelector('cart-drawer') === null || /\/cart\/?$/.test(location.pathname)) {
      location.reload();
      return;
    }
    var cart = await (await fetch(root + 'cart.js')).json();
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
  } catch (err) {
    knop.disabled = false;
    knop.removeAttribute('aria-busy');
  }
});
